/* Homepage motion. Combines wireJourney() (the hero film) from journey.js with
   wireHomepageMotion() from home-motion.js, both in
   serious-readers-brand-2026/public.

   One change: the prototype scoped the reveal to a .homepage-refresh wrapper.
   Each V4 section is its own Shopify section now, so there is no shared
   wrapper and the scope is the document. This script only loads on the
   homepage, so that is the same set of elements. */
(function () {
  var REVEAL_TARGETS = [
    '.home-shop .section-top',
    '.format-tile',
    '.proof-heading',
    '.image-proof-grid article',
    '.feature-photo',
    '.feature-copy',
    '.optician-rail-heading',
    '.reviews-heading',
    '.guidance-intro',
    '.guidance-preview',
    '.capture-resource',
    '.capture-form',
    '.founder-image',
    '.founder-copy',
    '.belief-heading',
  ].join(',');

  var cleanup = null;

  function saveData() {
    return !!(navigator.connection && navigator.connection.saveData);
  }

  function wireFilm() {
    document.querySelectorAll('video.cinema-film').forEach(function (video) {
      if (video.dataset.v4Wired === 'true') return;
      video.dataset.v4Wired = 'true';

      var play = function () {
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (saveData()) return;
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
      };

      play();
      if (!window.IntersectionObserver) return;
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) play();
            else video.pause();
          });
        },
        { threshold: 0.05 }
      ).observe(video);
    });
  }

  function wireReveal() {
    if (cleanup) cleanup();
    cleanup = null;
    if (!window.IntersectionObserver || !Element.prototype.animate) return;

    var preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (preference.matches) return;

    var running = new Set();
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          if (preference.matches || entry.target.contains(document.activeElement)) return;
          var animation = entry.target.animate(
            [
              { opacity: 0.35, transform: 'translateY(16px)' },
              { opacity: 1, transform: 'translateY(0)' },
            ],
            { duration: 650, easing: 'cubic-bezier(.22, 1, .36, 1)' }
          );
          running.add(animation);
          animation.finished.then(
            function () { running.delete(animation); },
            function () { running.delete(animation); }
          );
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px 50px 0px' }
    );

    // Never replay what is already on screen when the page loads.
    document.querySelectorAll(REVEAL_TARGETS).forEach(function (target) {
      if (target.getBoundingClientRect().top >= window.innerHeight - 20) observer.observe(target);
    });

    var stop = function () {
      observer.disconnect();
      running.forEach(function (animation) { animation.cancel(); });
      running.clear();
    };
    var onChange = function (event) { if (event.matches) stop(); };

    if (preference.addEventListener) preference.addEventListener('change', onChange);
    else if (preference.addListener) preference.addListener(onChange);

    cleanup = function () {
      stop();
      if (preference.removeEventListener) preference.removeEventListener('change', onChange);
      else if (preference.removeListener) preference.removeListener(onChange);
    };
  }

  function init() {
    wireFilm();
    wireReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
